import { render, staticRenderFns } from "./_Label.vue?vue&type=template&id=316572d4&scoped=true&"
import script from "./_Label.vue?vue&type=script&lang=js&"
export * from "./_Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316572d4",
  null
  
)

export default component.exports